(() => {
  const STYLE_ID = "shadow-forms-overrides-v4";

  const REQUIRED_FIELD_IDS = new Set([
    "email",
    "first_name",
    "last_name",
    "custom#subject",
    "custom#message_1"
  ]);

  /* ✅ Placeholder overrides */
  const PLACEHOLDER_OVERRIDES = {
    email: "your@email.com",
    "custom#company_name": "Company",
    "custom#message_1": "Write your message"
  };

  const css = `
    /* Make the whole embed/container actually wide */
    :host{
      --inline-container-max-width: 87rem !important;
      --container-max-w: 87rem !important;
      --app-embed-width: 100% !important;
    }

    /* Ensure wrapper sections can expand */
    [data-testid="app-router"],
    #form-container-ref,
    section[role="dialog"],
    ._inline_1q1d2_47,
    ._formContainer_1q1d2_30{
      width: 100% !important;
      max-width: 87rem !important;
      margin-left: auto !important;
      margin-right: auto !important;
      box-sizing: border-box !important;
    }

    /* Form spacing */
    form[data-testid="form"]{
      padding-top: 30px !important;
      width: 100% !important;
      box-sizing: border-box !important;
    }

    /* --- Critical: force fields to fill available width --- */
    form[data-testid="form"] input,
    form[data-testid="form"] textarea,
    form[data-testid="form"] button[type="submit"],
    form[data-testid="form"] ._selectToggle_12thd_25{
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    /* Ensure field wrappers are full width too */
    form[data-testid="form"] ._formFieldContainer_1mxsl_5,
    form[data-testid="form"] ._selectContainer_12thd_6,
    form[data-testid="form"] ._formFileInput_ehvsf_1{
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    /* --- Grid layout: default is full width; First/Last become 2 columns --- */
    form[data-testid="form"]{
      display: grid !important;
      grid-template-columns: minmax(0,1fr) minmax(0,1fr) !important;
      column-gap: 24px !important;
      row-gap: 18px !important;
    }

    /* Default: everything spans full width */
    form[data-testid="form"] > *{
      grid-column: 1 / -1 !important;
      min-width: 0 !important;
    }

    /* Half fields keep their own column */
    form[data-testid="form"] > .js-half,
    form[data-testid="form"] > .jm-fieldgroup.js-half{
      grid-column: span 1 !important;
      min-width: 0 !important;
    }

    form[data-testid="form"] button[type="submit"]{
      transition-property: all !important;
      transition-duration: .3s !important;
      transition-timing-function: cubic-bezier(.4, 0, .2, 1) !important;
    }

    form[data-testid="form"] button[type="submit"]:hover{
      background: #000;
      color: #fff;
    }

    ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10{
      font: inherit !important;
      font-size: 14px !important;
    }

    @media (max-width: 640px){
      form[data-testid="form"]{
        grid-template-columns: 1fr !important;
      }
      form[data-testid="form"] > .js-half,
      form[data-testid="form"] > .jm-fieldgroup.js-half{
        grid-column: 1 / -1 !important;
      }
    }

    /* --- Added top labels (keep original floating labels as-is) --- */
    .js-toplabel{
      margin: 0 0 6px 0 !important;
      font-size: 14px !important;
      line-height: 1.2 !important;
      color: var(--form-text-color, #202020) !important;
      font-weight: 500 !important;
      display: block !important;
      z-index: 1;
      top: 34.5px !important;
    }
    .js-toplabel .req{
      color: #e02229;
      font-weight: 600;
      margin-left: 2px;
    }
    label, ._label_12thd_10{
      display: none;
    }
    input, textarea{
      padding-top: 10px !important;
      padding-bottom: 10px !important;
      z-index: 2 !important;
    }

    /* Force placeholder to be visible */
    input::placeholder,
    textarea::placeholder{
      color: var(--form-placeholder-color, #20202080) !important;
      opacity: 1 !important;
    }

    /* --- Attach files styling + helper text --- */
    ._formFileInput_ehvsf_1 ._formFileInputField_ehvsf_5{
      border: 1px dashed rgba(0,0,0,.18) !important;
      border-radius: 10px !important;
      padding: 22px 16px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 10px !important;
      background: #fff !important;
    }
    ._formFileInput_ehvsf_1 ._formFileInputButton_ehvsf_18{
      margin: 0 !important;
      padding: 0 !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      color: #202020 !important;
    }
    .js-attach-icon{
      display: inline-flex;
      width: 16px;
      height: 16px;
    }
    .js-attach-icon svg{
      width: 16px;
      height: 16px;
    }
    .js-attach-helper{
      margin: 8px 0 0 0 !important;
      font-size: 12px !important;
      line-height: 1.3 !important;
      color: rgba(0,0,0,.55) !important;
    }

    /* Submit button radius */
    button[data-testid="btn-form-submit"]{
      border-radius: 30px !important;
      width: 100% !important;
    }

    /* ✅ Wrapper that holds field + its error, so error doesn't break grid */
    output[role="alert"]{
      display: none;
    }

    .jm-fieldgroup{
      display: grid !important;
      grid-template-rows: auto auto !important;
      gap: 6px !important;
      min-width: 0 !important;
    }
    .jm-fieldgroup output[role="alert"]{
      display: block !important;
      margin: 0 !important;
    }
    ._selectContainer_12thd_6 output[role="alert"]{
       display: block !important;
    }

    /* -----------------------------------
      Force First & Last Name to 50% width
    ------------------------------------ */

    /* Default: all field groups full width */
    form[data-testid="form"] > .jm-fieldgroup{
      grid-column: 1 / -1 !important;
      min-width: 0 !important;
    }

    /* First & Last Name = 50% */
    form[data-testid="form"] > .jm-fieldgroup:has(#first_name),
    form[data-testid="form"] > .jm-fieldgroup:has(#last_name){
      grid-column: span 1 !important;
    }

    /* Mobile safety: stack everything */
    @media (max-width: 640px){
      form[data-testid="form"] > .jm-fieldgroup{
        grid-column: 1 / -1 !important;
      }
    }

    @media screen and (max-width: 490px) {
      ._container_3eyaa_70 {
        display: block !important;
      }
    }


  `;

  function injectStyles(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function addTopLabel(wrap, text, required) {
    if (!wrap || wrap.querySelector(":scope > .js-toplabel")) return;
    const p = document.createElement("p");
    p.className = "js-toplabel";
    p.textContent = text;

    if (required) {
      const star = document.createElement("span");
      star.className = "req";
      star.textContent = "*";
      p.appendChild(star);
    }
    wrap.insertBefore(p, wrap.firstChild);
  }

  function setHalfWidthFields(shadowRoot) {
    const first = shadowRoot.querySelector('[data-testid="field-first_name"]');
    const last  = shadowRoot.querySelector('[data-testid="field-last_name"]');

    const firstWrap = first?.closest("div._formFieldContainer_1mxsl_5") || first?.closest("div");
    const lastWrap  = last?.closest("div._formFieldContainer_1mxsl_5") || last?.closest("div");

    if (firstWrap) firstWrap.classList.add("js-half");
    if (lastWrap) lastWrap.classList.add("js-half");
  }

  function buildTopLabels(shadowRoot) {
    const form = shadowRoot.querySelector('form[data-testid="form"]');
    if (!form) return;

    form.querySelectorAll("div._formFieldContainer_1mxsl_5").forEach((wrap) => {
      const control = wrap.querySelector("input, textarea");
      if (!control) return;

      const id = control.id || "";
      const name = control.getAttribute("name") || "";

      const labelEl =
        wrap.querySelector(`label[for="${CSS.escape(id)}"]`) ||
        wrap.querySelector("label");

      const labelText = (labelEl?.textContent || "").trim();
      if (!labelText) return;

      const isRequired =
        control.getAttribute("aria-required") === "true" ||
        control.required ||
        REQUIRED_FIELD_IDS.has(id) ||
        REQUIRED_FIELD_IDS.has(name);

      addTopLabel(wrap, labelText, isRequired);
    });

    // Category (custom select)
    const selectWrap = form.querySelector("div._selectContainer_12thd_6");
    if (selectWrap) {
      const label = selectWrap.querySelector("p._label_12thd_10, p");
      const text = (label?.textContent || "Category").trim();
      addTopLabel(selectWrap, text || "Category", true);
    }

    // Message textarea special-case (if not captured above)
    const msg = form.querySelector("textarea._textArea_17mgw_1");
    if (msg) {
      const wrap = msg.closest("div") || msg.parentElement;
      if (wrap && !wrap.querySelector(":scope > .js-toplabel")) {
        const label =
          form.querySelector('label[id^="label-custom#message"]') ||
          wrap.querySelector("label");
        const text = (label?.textContent || "Message").trim();
        addTopLabel(wrap, text, true);
      }
    }
  }

  /* ✅ Apply placeholders */
  function applyPlaceholders(shadowRoot) {
    const form = shadowRoot.querySelector('form[data-testid="form"]');
    if (!form) return;

    Object.entries(PLACEHOLDER_OVERRIDES).forEach(([key, val]) => {
      let el = form.querySelector(`#${CSS.escape(key)}`);
      if (!el) el = form.querySelector(`[name="${CSS.escape(key)}"]`);
      if (el) el.setAttribute("placeholder", val);
    });

    form.querySelectorAll("input, textarea").forEach((field) => {
      const id = field.id || "";
      const name = field.getAttribute("name") || "";

      if (PLACEHOLDER_OVERRIDES[id] || PLACEHOLDER_OVERRIDES[name]) return;

      const current = (field.getAttribute("placeholder") || "").trim();
      if (current) return;

      const label =
        (id && form.querySelector(`label[for="${CSS.escape(id)}"]`)) ||
        field.closest("div")?.querySelector("label");

      const fallback = (label?.textContent || "").replace("*", "").trim();
      if (fallback) field.setAttribute("placeholder", fallback);
    });
  }

  function fixAttachFilesUI(shadowRoot) {
    const form = shadowRoot.querySelector('form[data-testid="form"]');
    if (!form) return;

    const fileBlock = form.querySelector("._formFileInput_ehvsf_1");
    if (!fileBlock) return;

    if (!fileBlock.querySelector(".js-attach-helper")) {
      const helper = document.createElement("p");
      helper.className = "js-attach-helper";
      helper.textContent = "The maximum allowed size per file is 10 MB.";
      fileBlock.appendChild(helper);
    }
  }

  /* ✅ NEW: Wrap each field container with its immediate error <output> so it doesn't break grid */
  function groupFieldErrors(shadowRoot) {
    const form = shadowRoot.querySelector('form[data-testid="form"]');
    if (!form) return;

    const isFieldContainer = (el) =>
      el && el.nodeType === 1 && el.classList && el.classList.contains("_formFieldContainer_1mxsl_5");

    // Process all field containers in order
    form.querySelectorAll("div._formFieldContainer_1mxsl_5").forEach((fieldEl) => {
      // Already wrapped?
      if (fieldEl.parentElement?.classList?.contains("jm-fieldgroup")) return;

      const next = fieldEl.nextElementSibling;
      if (!next || next.tagName !== "OUTPUT" || next.getAttribute("role") !== "alert") return;

      // Create wrapper and keep "js-half" behavior
      const wrapper = document.createElement("div");
      wrapper.className = "jm-fieldgroup";
      if (fieldEl.classList.contains("js-half")) wrapper.classList.add("js-half");

      // Insert wrapper in place, then move nodes
      fieldEl.parentNode.insertBefore(wrapper, fieldEl);
      wrapper.appendChild(fieldEl);
      wrapper.appendChild(next);
    });

    // Also handle select container error output inside the select wrap (different structure)
    form.querySelectorAll("div._selectContainer_12thd_6").forEach((selectWrap) => {
      if (selectWrap.parentElement?.classList?.contains("jm-fieldgroup")) return;

      const output = selectWrap.querySelector('output[role="alert"]');
      if (!output) return;

      // If selectWrap has an output INSIDE, leave it inside; just ensure the selectWrap itself behaves as one grid item.
      // (No DOM move needed, but we can optionally ensure selectWrap spans correctly via CSS already.)
    });
  }

  function observeAndGroupErrors(shadowRoot) {
  const form = shadowRoot.querySelector('form[data-testid="form"]');
  if (!form) return;

  const wrapError = (output) => {
    if (
      !output ||
      output.tagName !== "OUTPUT" ||
      output.getAttribute("role") !== "alert"
    ) return;

    const prev = output.previousElementSibling;
    if (!prev) return;

    // Only wrap real field containers
    const isField =
      prev.classList?.contains("_formFieldContainer_1mxsl_5") ||
      prev.classList?.contains("_selectContainer_12thd_6");

    if (!isField) return;

    // Already wrapped → do nothing
    if (prev.parentElement?.classList.contains("jm-fieldgroup")) return;

    const wrapper = document.createElement("div");
    wrapper.className = "jm-fieldgroup";

    // Preserve half-width layout
    if (prev.classList.contains("js-half")) {
      wrapper.classList.add("js-half");
    }

    // Insert wrapper and move nodes
    prev.parentNode.insertBefore(wrapper, prev);
    wrapper.appendChild(prev);
    wrapper.appendChild(output);
  };

  // Initial pass (in case errors already exist)
  form.querySelectorAll('output[role="alert"]').forEach(wrapError);

  // Observe future injections
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (
          node.nodeType === 1 &&
          node.tagName === "OUTPUT" &&
          node.getAttribute("role") === "alert"
        ) {
          wrapError(node);
        }
      });
    });
  });

  observer.observe(form, { childList: true });
}

  const FIELD_WRAPPER_SEL = "div._formFieldContainer_1mxsl_5, div._selectContainer_12thd_6, div._formFileInput_ehvsf_1";

  function ensureFieldGroupForNode(node) {
    if (!node) return null;
    const existingGroup = node.closest(".jm-fieldgroup");
    if (existingGroup) return existingGroup;

    // Create wrapper and move node into it
    const group = node.ownerDocument.createElement("div");
    group.className = "jm-fieldgroup";

    const parent = node.parentNode;
    if (!parent) return null;

    parent.insertBefore(group, node);
    group.appendChild(node);
    return group;
  }

  function findOwnerFieldForOutput(form, out) {
    // Prefer an immediate previous field wrapper (Shopify usually inserts output after field)
    let prev = out.previousElementSibling;

    if (prev && prev.matches(FIELD_WRAPPER_SEL)) return prev;

    // If outputs got dumped at end, walk backwards from output until we hit a wrapper
    let cur = out.previousElementSibling;
    while (cur) {
      if (cur.matches && cur.matches(FIELD_WRAPPER_SEL)) return cur;
      cur = cur.previousElementSibling;
    }

    // Fallback: if none found near it, do nothing
    return null;
  }

  function rehomeOutputs(shadowRoot) {
    const form = shadowRoot.querySelector('form[data-testid="form"]');
    if (!form) return;

    // Handle *all* outputs, including ones dumped at the bottom
    const outputs = Array.from(form.querySelectorAll('output[role="alert"]'));

    outputs.forEach((out) => {
      // If already correctly grouped, skip
      if (out.closest(".jm-fieldgroup")) return;

      const ownerField = findOwnerFieldForOutput(form, out);
      if (!ownerField) return;

      // Ensure the owner field is grouped
      const group = ensureFieldGroupForNode(ownerField);
      if (!group) return;

      // Move output inside the group, directly after the owner field
      // (This keeps layout stable and predictable)
      if (ownerField.nextSibling) {
        group.insertBefore(out, ownerField.nextSibling);
      } else {
        group.appendChild(out);
      }
    });
  }

  function bindOutputObserver(shadowRoot) {
    const form = shadowRoot.querySelector('form[data-testid="form"]');
    if (!form) return;

    if (form.dataset.jmOutputsBound === "1") return;
    form.dataset.jmOutputsBound = "1";

    // Run once now
    rehomeOutputs(shadowRoot);

    // Observe ONLY the form subtree, not the whole document (performance-safe)
    const obs = new MutationObserver((mutations) => {
      // Only react if outputs were added/changed
      let needs = false;

      for (const m of mutations) {
        if (m.type === "childList") {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches?.('output[role="alert"]') || n.querySelector?.('output[role="alert"]')) {
              needs = true;
              break;
            }
          }
        } else if (m.type === "attributes") {
          if (m.target?.matches?.('output[role="alert"]')) needs = true;
        }
        if (needs) break;
      }

      if (!needs) return;

      // Batch in next frame to avoid thrashing
      requestAnimationFrame(() => rehomeOutputs(shadowRoot));
    });

    obs.observe(form, {
      childList: true,
      subtree: true
    });
  }



  function applyAll(shadowRoot) {
    injectStyles(shadowRoot);
    setHalfWidthFields(shadowRoot);
    buildTopLabels(shadowRoot);

    applyPlaceholders(shadowRoot);
    setTimeout(() => applyPlaceholders(shadowRoot), 50);

    groupFieldErrors(shadowRoot); // ✅ NEW
    setTimeout(() => groupFieldErrors(shadowRoot), 0); // cover async validation render

    fixAttachFilesUI(shadowRoot);

     observeAndGroupErrors(shadowRoot);

  }

  function tryInjectAll() {
    document.querySelectorAll("shopify-forms-embed").forEach((el) => {
      if (el.shadowRoot) applyAll(el.shadowRoot);
    });
  }

  // Run now
  tryInjectAll();

  // Watch for re-renders
  const mo = new MutationObserver(() => tryInjectAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Short polling window for async shadow attach
  let tries = 0;
  const timer = setInterval(() => {
    tryInjectAll();
    tries += 1;
    if (tries >= 40) clearInterval(timer);
  }, 250);
})();
